/**
 * @generated SignedSource<<12f168b778b5bb5b1945ea341a7aa5d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Operations$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OperationsMenuForLanding">;
  readonly " $fragmentType": "Nav4Operations";
};
export type Nav4Operations$key = {
  readonly " $data"?: Nav4Operations$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Operations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isOperationsExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Operations",
  "selections": [
    {
      "condition": "isOperationsExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "OperationsMenuForLanding"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "3ba981daf80c70dad77a979656f4a679";

export default node;
